import styled from '@emotion/styled';
import { Typography as _Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment } from 'react';

import { DynamicSchemaDefinitionSelectOne } from '../../../../../generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionSelectOne, 'choices' | 'label'>;
  value: string;
  latestValue: string;
  beforeValue: string;
  className?: string;
}

const AsSelection = ({ field, latestValue, beforeValue, className }: Props & ClassAttributes<HTMLElement>) => {
  const latestCorrespondingChoice = field.choices.find((c) => c.key === latestValue);
  const beforeCorrespondingChoice = field.choices.find((c) => c.key === beforeValue);
  if (!latestCorrespondingChoice || !beforeCorrespondingChoice) {
    return null;
  }

  return (
    <Base field={field} className={className}>
      {JSON.stringify(latestCorrespondingChoice) === JSON.stringify(beforeCorrespondingChoice) ? (
        <Value variant="body1">{latestCorrespondingChoice.label ? latestCorrespondingChoice.label : '-'}</Value>
      ) : (
        <>
          <Before variant="body1">{beforeCorrespondingChoice.label ? beforeCorrespondingChoice.label : '　'}</Before>
          <After variant="body1">{latestCorrespondingChoice.label ? latestCorrespondingChoice.label : '　'}</After>
        </>
      )}
    </Base>
  );
};

const Value = styled(_Typography)({});

const Before = styled(_Typography)({
  padding: '4px',
  marginBottom: '8px',
  background: '#fdd7d5',
});

const After = styled(_Typography)({
  padding: '4px',
  background: '#c8ffd8',
});

export default AsSelection;
